var Favorites = module.exports = {
  remember: function(url, holder) {
    this.trackEvent(url);
    $.ajax({type: 'post', url: url + '.json', dataType: 'json', data: {},
      success: function(response_data) {
        if(response_data) {
          $.jGrowl(T.t('remembered_success'));
          if(holder) {
            holder.slideUp();
          }
        } else {
          $.jGrowl(response_data.message);
        }
        $.prettyLoader.hide();
      },
      error: function() {
        $.jGrowl(T.t('something_went_wrong'), {sticky: true});
        $.prettyLoader.hide();
      }
    });
  },
  trackEvent: function(url) {
    if (window.amplitude) {
      const path = window.location.pathname;
      let [assetType, assetId] = (url.match(/(route|trip)\/(\d+)$/) || []).slice(-2);
      let pinSource = null;
      assetType = assetType === 'trip' ? 'ride' : 'route';

      if (/find$/.test(path)) {
        pinSource = 'findPage';
      } else if (/clubs\/[^\/]+\/routes$/.test(path)) {
        pinSource = 'orgRouteLibrary';
      }

      window.amplitude.track('Click Pin', {
        asset_id: parseInt(assetId),
        asset_type: assetType,
        pin_source: pinSource,
        user_pinned: true
      });
    }
  }
}

$(function() {
  $('body').on('click', '.remember_this', function() {
    var $self = $(this)
    Favorites.remember($self.attr("href"), $self.parent());
    return false;
  });
});



// WEBPACK FOOTER //
// ./public/javascripts/favorites.js